import moment from 'moment/moment'

import { INVOICE_MONTH_FORMAT_DATE } from './constants'

export default function invoiceMonthFormat(date, format = 'MMMM') {
  if (!date) return null
  return moment(date, INVOICE_MONTH_FORMAT_DATE).format(format)
}
